import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid2';

import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import clientConfig from '../../../client-config';

const VideoAssign = () => {
  const [treeData, setTreeData] = useState([]);
  const [selectedKey, setSelectedKey] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const [videos, setVideos] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [editingVideo, setEditingVideo] = useState(null);

  useEffect(() => {
    axios
      .get(`${clientConfig.backendHOST}/video/videoKategoriaNav`, {
        headers: {
          'x-auth-token': localStorage.token,
        },
      })
      .then((res) => setTreeData(res.data));
  }, []);

  useEffect(() => {
    if (selectedKey && selectedType) {
      axios
        .get(`${clientConfig.backendHOST}/video/video`, {
          headers: {
            'x-auth-token': localStorage.token,
          },
          params: { type: selectedType, key: selectedKey },
        })
        .then((res) => setVideos(res.data));
    }
  }, [selectedKey, selectedType]);

  const renderTreeItems = (nodes) => (
    <TreeItem
      key={nodes.key}
      itemId={nodes.key.toString()}
      label={nodes.text}
      onClick={() => {
        setSelectedKey(nodes.key);
        setSelectedType(nodes.type);
      }}
    >
      {Array.isArray(nodes.items)
        ? nodes.items.map((node) => renderTreeItems(node))
        : null}
    </TreeItem>
  );

  const handleEditClick = (video) => {
    setEditingVideo(video);
    setOpenDialog(true);
  };

  const handleSave = async () => {
    const url = `${clientConfig.backendHOST}/video/video`;
    if (editingVideo.videoId) {
      await axios.put(url, editingVideo, {
        headers: { 'x-auth-token': localStorage.token },
      });
    } else {
      await axios.post(url, editingVideo, {
        headers: { 'x-auth-token': localStorage.token },
      });
    }
    setOpenDialog(false);
    if (selectedKey && selectedType) {
      const res = await axios.get(`${clientConfig.backendHOST}/video/video`, {
        headers: {
          'x-auth-token': localStorage.token,
        },
        params: { type: selectedType, key: selectedKey },
      });
      setVideos(res.data);
    }
  };

  const columns = [
    { field: 'videoCim', headerName: 'Videó címe', flex: 1, minWidth: 200 },
    {
      field: 'video_vimeoUrl',
      headerName: 'Vimeo URL',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'free',
      headerName: 'Ingyenes',
      type: 'boolean',
      width: 120,
    },
    {
      field: 'sortOrder',
      headerName: 'Sorrend',
      type: 'number',
      width: 120,
    },
    {
      field: 'actions',
      headerName: '',
      width: 100,
      renderCell: (params) => (
        <Button size='small' onClick={() => handleEditClick(params.row)}>
          Szerkesztés
        </Button>
      ),
    },
  ];

  return (
    <Box p={3} display='flex' flexDirection='column' alignItems='center'>
      <Typography variant='h4' gutterBottom>
        Videók szerkesztése
      </Typography>
      <Button
        variant='contained'
        sx={{ alignSelf: 'flex-center', mb: 2 }}
        onClick={() => {
          setEditingVideo({
            videoCim: '',
            videoLeiras: '',
            video_vimeoUrl: '',
            sortOrder: 0,
            free: 0,
            ...(selectedType === 'cat'
              ? { kategoriaId: selectedKey }
              : { kategoriaMappaId: selectedKey }),
          });
          setOpenDialog(true);
        }}
        disabled={!selectedKey || !selectedType}
      >
        Új videó hozzáadása
      </Button>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Paper sx={{ padding: 2 }}>
            <SimpleTreeView>
              {Array.isArray(treeData) &&
                treeData.map((node) => renderTreeItems(node))}
            </SimpleTreeView>
          </Paper>
        </Grid>
        <Grid item xs={12} md={9}>
          <Paper>
            <DataGrid
              rows={videos}
              getRowId={(row) => row.videoId}
              columns={columns}
              pageSize={10}
              rowsPerPageOptions={[10, 25, 50]}
              components={{ Toolbar: GridToolbar }}
            />
          </Paper>
        </Grid>
      </Grid>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle>Videó szerkesztése</DialogTitle>
        <DialogContent>
          <TextField
            label='Cím'
            fullWidth
            margin='normal'
            value={editingVideo?.videoCim || ''}
            onChange={(e) =>
              setEditingVideo({ ...editingVideo, videoCim: e.target.value })
            }
          />
          <TextField
            label='Leírás'
            fullWidth
            multiline
            minRows={3}
            margin='normal'
            value={editingVideo?.videoLeiras || ''}
            onChange={(e) =>
              setEditingVideo({ ...editingVideo, videoLeiras: e.target.value })
            }
          />
          <TextField
            label='Vimeo URL'
            fullWidth
            margin='normal'
            value={editingVideo?.video_vimeoUrl || ''}
            onChange={(e) =>
              setEditingVideo({
                ...editingVideo,
                video_vimeoUrl: e.target.value,
              })
            }
          />
          <TextField
            label='Sorrend'
            fullWidth
            type='number'
            margin='normal'
            value={editingVideo?.sortOrder || ''}
            onChange={(e) =>
              setEditingVideo({ ...editingVideo, sortOrder: e.target.value })
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={
                  editingVideo?.free === 1 || editingVideo?.free === true
                }
                onChange={(e) =>
                  setEditingVideo({
                    ...editingVideo,
                    free: e.target.checked ? 1 : 0,
                  })
                }
              />
            }
            label='Ingyenes videó'
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Mégse</Button>
          <Button variant='contained' onClick={handleSave}>
            Mentés
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default VideoAssign;
